import { render, staticRenderFns } from "./RemoveSpotIcon.vue?vue&type=template&id=79e0c4dc&scoped=true&"
import script from "./RemoveSpotIcon.vue?vue&type=script&lang=js&"
export * from "./RemoveSpotIcon.vue?vue&type=script&lang=js&"
import style0 from "./RemoveSpotIcon.vue?vue&type=style&index=0&id=79e0c4dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e0c4dc",
  null
  
)

export default component.exports